const state = {
    contacts: [],
    contactId: [],
    loading: false
};

export default state;